export enum Roles {
  ContractorAdmin = "ContractorAdmin",
  ContractorUser = "ContractorUser",
}
